import { Component, ViewChild } from '@angular/core';
import { DialogService } from 'src/app/layout/services/dialog.service';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { environment } from 'src/environments/environment';
import { ConfigService } from './config.service';
import { AddConfigComponent } from './add-config/add-config.component';
import { IConfigUpdatePayload } from './config.interface';
import { helper } from 'src/environments/helper';
import { EditConfigComponent } from './edit-config/edit-config.component';
import { PermissionsService } from '../../../../../services/permissions.service';

@Component({
    selector: 'app-configurari',
    templateUrl: './configurari.component.html',
    styleUrls: ['./configurari.component.scss'],
})
export class ConfigurariComponent {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    helper = helper;

    isLoading = false;
    showCard = false;
    activeValue: string = '-1';
    publicValue: string = '-1';
    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    dtLink =
        environment.interop.basePath +
        environment.interop.autorizatiiComerciale.settings.configurations.getConfigurationsDT;

    parameters: { key: string; value: string }[] = [
        { key: '--Alegeți--', value: '-1' },
        { key: 'Da', value: '0' },
        { key: 'Nu', value: '1' },
    ];

    resetForm() {
        this.activeValue = '-1';
        this.publicValue = '-1';

        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.rerenderDT(true);
    }

    toggleCard() {
        this.showCard = !this.showCard;
    }

    constructor(
        private dialogService: DialogService,
        private http: HttpClient,
        private dialog: MatDialog,
        private configService: ConfigService,
        public permissionsService: PermissionsService
    ) { }

    ngOnInit(): void {
        this.renderDT();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            pagingType: 'full_numbers',
            responsive: true,
            pageLength: 25,
            searching: false,
            lengthMenu: [10, 25, 50, 100],
            serverSide: true,
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                dataTablesParameters.param1 = this.activeValue;
                dataTablesParameters.param2 = this.publicValue;

                this.http
                    .post<DataTablesResponse>(
                        this.dtLink, // datatable link, we need this
                        dataTablesParameters // parameters for filtering, send here
                    )
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'ID',
                    data: 'id_configuration',
                },
                {
                    title: 'Denumire',
                    data: 'name',
                },
                {
                    title: 'Valoare',
                    data: 'value',
                },
                {
                    title: 'Acțiuni',
                    data: null,
                    className: 'all',
                    orderable: false,
                    render: () => {
                        return `
							<button class="action-btn edit">
								<img class="btn-img" src="../../../../assets/icons/edit.svg" alt="edit"/>
							</button>
						`;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const editIcon = lastTd?.querySelector('.edit') as HTMLElement;
                // const deleteIcon = lastTd?.querySelector('.delete') as HTMLElement;

                if (editIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            "autcom-module.administrative.configurations.update"
                        )
                    ) {
                        editIcon.style.display = "none";
                    }
                    editIcon.addEventListener('click', () => {
                        this.openEditDialog(data);
                    });
                }

                // if (deleteIcon) {
                // 	if (
                //         !this.permissionsService.hasPermission(
                //             "autcom-module.administrative.configurations.delete"
                //         )
                //     ) {
                //         deleteIcon.style.display = "none";
                //     }
                // 	deleteIcon.addEventListener('click', () => {
                // 		this.deleteConfig(data);
                // 	});
                // }

                return row;
            },
        };
    }

    rerenderDT(resetPaging = false): void {
        this.isLoading = true;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(resetPaging);
            this.isLoading = false;
        });
        this.showCard = false;
    }

    openAddDialog() {
        const dialogRef = this.dialog.open(AddConfigComponent, {
            ...this.dialogService.getDialogConfig(),
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Adăugată cu succes!',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    openEditDialog(data: IConfigUpdatePayload) {
        const dialogRef = this.dialog.open(EditConfigComponent, {
            ...this.dialogService.getDialogConfig(),
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Actualizare cu succes!',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    // deleteConfig(id: number) {
    //     Swal.fire({
    //       title: "Sunteți sigur?",
    //       text: "Nu o să puteți recupera datele odată cu ștergerea lor!",
    //       icon: "warning",
    //       showCancelButton: true,
    //       confirmButtonColor: "#DD6B55",
    //       confirmButtonText: "Confirm!",
    //       cancelButtonText: "Cancel",
    //       showLoaderOnConfirm: true,
    //     }).then((result) => {
    //       if (result.isConfirmed) {
    //         this.isLoading = true;
    //         this.configService
    //           .deleteConfig(id)
    //           .pipe(finalize(() => (this.isLoading = false)))
    //           .subscribe(() => {
    //             this.rerenderDT();
    //             Swal.fire({
    //               title: "Șters!",
    //               text: "Configurare ștearsă cu succes.",
    //               icon: "success",
    //               confirmButtonText: "OK",
    //             });
    //           });
    //       }
    //     });
    //   }
}
